var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',_vm._l((_vm.value),function(item){return _c('v-list-item',{key:item.state.stateDesc},[_c('v-list-item-action',[_c('v-checkbox',{attrs:{"label":item.state.stateDesc},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }